import { render, staticRenderFns } from "./status-area.vue?vue&type=template&id=6a220c9c&scoped=true"
import script from "./status-area.ts?vue&type=script&lang=ts&external"
export * from "./status-area.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a220c9c",
  null
  
)

export default component.exports